import { UUID } from '@/types';
import { useDatasourceId } from '@/hooks';
import { useGetSavedQueryColumnsQuery } from '@/features/query-builder/savedQueriesApiSlice';

export const useGetColumns = (seriesId: UUID) => {
  const datasourceId = useDatasourceId();
  const { data } = useGetSavedQueryColumnsQuery({
    datasourceId,
    seriesId,
  });

  return data?._columns;
};
